import { Routes, Route } from "react-router-dom";

import UserList from "./UserList";
import User from "./User";
import NotFound from "$components/NotFound";

const Projects = () => {
  return (
    <Routes>
      <Route path="/" element={<UserList />} />
      <Route path="/:userId" element={<User />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Projects;
